module.exports = __webpack_public_path__ + "assets/1abf98379b24e3660ec7a7f4db24b1e3.json";